import React from 'react'
import PropTypes from 'prop-types'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'
import logo from '../images/logo.png';

import './index.css';
import '../css/slick.css';
import {css} from 'glamor';

const root = css({
  minHeight: '100%'
})
const container = css({
  padding: '20px',
  margin: '0 auto',
  minHeight: '100%',
  '@media(max-width: 650px)': {
    padding: '10px'
  }
})
const mainContent = css({
  position: 'absolute',
  left: 0,
  top: 100,
  right: 0,
  bottom: 0
});
const relative = css({
  position: 'relative'
});
const headerInner = css({
  '@media(max-width: 650px)': {
    display: 'flex',
    flexDirection: 'column'
  }
});
const headerLogo = css({
  margin: '0 auto',
  maxWidth: '300px',
  height: '60px',
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'contain',
  backgroundPosition: 'center',
  textIndent: '-9999px',
  '@media(max-width: 650px)': {
    maxWidth: '200px',
  }
});
const footer = css({
  padding: '10px',
  marginTop: '50px',
  borderTop: '1px solid #999'
});
const footerInner = css({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  '@media(max-width: 650px)': {
    fontSize: '14px'
  }
})
const pageNavFooter = css({
  padding: '20px',
  display: 'flex'
});
const pageNav = css({
  padding: '40px 20px 20px',
  position: 'absolute',
  top: 0,
  right: 0,
  display: 'flex',
  '@media(max-width: 650px)': {
    padding: 0,
    position: 'static',
    fontSize: '14px'
  }
});
const pageNavLink = css({
  display: 'block',
  color: '#333',
  textDecoration: 'none',
  marginLeft: '10px',
  textTransform: 'uppercase'
});
const pageNavActive = css({
  borderBottom: '3px solid #7ea4ce'
})
const Header = ({data}) => (
  <div {...container} {...relative}>
    <div {...headerInner}>
      <Link to="/">
        <h1 className="logo" style={{backgroundImage: `url("${logo}")`}} {...headerLogo}>
          {data.site.siteMetadata.title}
        </h1>
      </Link>
      <div {...pageNav}>
        <Link to="/portfolio" activeClassName={pageNavActive} {...pageNavLink}>Portfolio</Link>
        <Link to="/about" activeClassName={pageNavActive} {...pageNavLink}>About</Link>
        <Link to="/contact" activeClassName={pageNavActive} {...pageNavLink}>Contact</Link>
      </div>
    </div>
  </div>
);

const Footer = ({data}) => (
  <div {...footer} {...relative}>
    <div {...container} {...footerInner}>
      <div>&copy; {data.site.siteMetadata.title} {new Date().getFullYear()}</div>
      <div {...pageNavFooter}>
        <Link to="/portfolio" {...pageNavLink}>Portfolio</Link>
        <Link to="/about" {...pageNavLink}>About</Link>
        <Link to="/contact" {...pageNavLink}>Contact</Link>
      </div>
    </div>
  </div>
);

const TemplateWrapper = ({children, data}) => (
  <div {...root}>
    <Helmet>
      <title>{data.site.siteMetadata.title}</title>
      <meta name="description" content="Interior design firm based in Austin, Texas specializing in design drawings, permit and construction document drafting, and finish and furnishing packages." />
    </Helmet>
    <Header data={data}/>
    <div {...mainContent}>
      {children()}
    </div>
  </div>
)

// <Footer data={data}/>

TemplateWrapper.propTypes = {
  children: PropTypes.func,
}

export const query = graphql`
  query LayoutQuery {
    site {
      siteMetadata {
        title
      }
    }
  }
`

export default TemplateWrapper



// WEBPACK FOOTER //
// ./src/layouts/index.js